export default [
  {
    name: 'BTC'
  },
  {
    name: 'ETH'
  },
]
